import React from 'react';
import PopupModal from "../../../../../../../../../components/Modal/PopupModal";
import {useTranslation} from "react-i18next";
import {ReactComponent as PinIco} from "../../../../../../../../../../images/icons/pin-outline.svg";
import {ConfigApi, MultistoreLayoutType, OrderType, PlaceApi} from "../../../../../../../../../services/Api/types";
import MultistorePlaceCard from "../../../../../../../components/PlaceCard/MultistorePlaceCard";
import {SessionState} from "../../../../../../../../../services/Session/types";

interface Props {
    show: boolean;
    onHide: () => void;
    places: PlaceApi[];
    session: SessionState;
    config: ConfigApi | undefined;
}

const MultistoreWithHomePagePlacesModal = ({show, onHide, places, session, config}: Props) => {
    const {t} = useTranslation();

    return (
        <PopupModal
            className="multistore-page places-modal"
            title={t("modules.multistore.field.choose_place.title")}
            headerIcon={<PinIco/>}
            show={show}
            onHide={onHide}
            description={t("modules.multistore.field.available_places_with_delivery.title")}
            bodyContent={
                <div className="d-flex flex-column gap-2 mt-2">
                    {places.map(place => (
                        <MultistorePlaceCard key={place.domain} place={place}
                                             layout={MultistoreLayoutType.HOME_WITH_MAP}
                                             forceOrderType={OrderType.DELIVERY}
                                             config={config}
                                             session={session}
                        />
                    ))}
                </div>
            }
        />
    )
}

export default MultistoreWithHomePagePlacesModal;